import { createInlineStyleButton } from '@draft-js-plugins/buttons';
import { FormatItalic } from '@mui/icons-material';

const ItalicButton = createInlineStyleButton({
  style: 'ITALIC',
  children: <FormatItalic />,
});

export default ItalicButton;
